import React from "react";
import "./ProfileHeader.scss";
import ProgressBar from "../../UI/ProgressBar/ProgressBar";
import { calculateCompletePercentage } from "../../Services/globalService";
import logo from "../../../assets/icons/edel_icons/Nuvama_Identity_RGB_Positive.jpg";

export interface ProfileHeaderProps {
  isMobileMenuOpen?: boolean;
  onToggleMobileMenu?: () => void;
  mobileMenuId?: string;
  mobileMenuButtonRef?: React.Ref<HTMLButtonElement>;
}

const ProfileHeader: React.FC<ProfileHeaderProps> = (props) => {
  const percentageComplete: string = calculateCompletePercentage();
  const progressLabelId = "profile-header-progress-label";

  return (
    <div className="prfHdr">
      <div className="desktop">
        <button
          type="button"
          className="mobileMenuToggle"
          aria-expanded={!!props.isMobileMenuOpen}
          aria-controls={props.mobileMenuId}
          aria-label={
            props.isMobileMenuOpen
              ? "Close navigation menu"
              : "Open navigation menu"
          }
          onClick={props.onToggleMobileMenu}
          ref={props.mobileMenuButtonRef}
        >
          <span className="hamburgerIcon" aria-hidden="true">
            <span />
            <span />
            <span />
          </span>
        </button>

        <img className="Logo-main" src={logo} alt="Nuvama logo" />

        <div className="progress">
          <span className="progressLbl" id={progressLabelId}>
            {percentageComplete}% complete
          </span>

          <ProgressBar
            percent={percentageComplete}
            width="120px"
            height="6px"
            ariaLabelledBy={progressLabelId}
          />
        </div>
      </div>
    </div>
  );
};

export default ProfileHeader;
